import React from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { Config, UiKit } from 'components';
import { useServiceWindowStartOptions } from '../../hooks';
import { PRODUCT_SKU_CONFIG_KEYS as DATA_KEYS } from '../../stubs';

export default function ExceptionConfig({
  data = {},
  error = {},
  isDisabled = false,
  setData = () => {}
}) {
  const startOptions = useServiceWindowStartOptions();

  const isActive = _get(data, DATA_KEYS.IS_ACTIVE, false);
  const name = _get(data, DATA_KEYS.NAME, '');
  const serviceDays = _get(data, DATA_KEYS.SERVICE_DAYS, '');
  const startsOnDelivery = _get(data, DATA_KEYS.STARTS_ON_DELIVERY, false);

  const nameError = _get(error, DATA_KEYS.NAME, '');
  const serviceDaysError = _get(error, DATA_KEYS.SERVICE_DAYS, '');
  const startsOnDeliveryError = _get(error, DATA_KEYS.STARTS_ON_DELIVERY, '');

  const onInputChange = (_, event) => {
    const { name, value } = event.target;
    setData(name, value);
  };

  const onToggle = value => setData(DATA_KEYS.IS_ACTIVE, value);
  const onStartChange = value => setData(DATA_KEYS.STARTS_ON_DELIVERY, value);

  const startOptionsRender = startOptions.map(option => (
    <UiKit.Radio.Option
      key={option.value}
      value={option.value}
      label={option.label}
      disabled={option.disabled}
    />
  ));

  return (
    <>
      <Config.Section>
        <Config.Activator
          isActive={isActive}
          onChange={onToggle}
          disabled={isDisabled}
        />
      </Config.Section>
      <Config.Section className={styles.container}>
        <UiKit.Grid templateColumns="1fr" gap="20">
          <UiKit.Input
            autoFocus
            name={DATA_KEYS.NAME}
            label="Title"
            value={name}
            onChange={onInputChange}
            disabled={isDisabled}
            placeholder="Enter title of the exception"
            error={nameError}
          />
          <UiKit.Input
            name={DATA_KEYS.SERVICE_DAYS}
            type="number"
            min="0"
            maxDecimalPrecision={0}
            label="Return Window (in days)"
            value={serviceDays}
            onChange={onInputChange}
            disabled={isDisabled}
            placeholder="Enter the number of serviceable days"
            error={serviceDaysError}
          />
          <UiKit.Radio.Group
            variant="inline"
            label="Return window starts from"
            value={startsOnDelivery}
            onChange={onStartChange}
            disabled={isDisabled}
            error={startsOnDeliveryError}
          >
            {startOptionsRender}
          </UiKit.Radio.Group>
        </UiKit.Grid>
      </Config.Section>
    </>
  );
}
